/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/* eslint-disable sort-keys */

/*
 * While onboarding another app in cjm.js, please identify
 * if there are sharable configs among apps and if yes, then
 * create a baseConfig object and move common configs there
*/

import {Sandbox} from '@exc/core';

// Temporary configuration while app hub svc is written.
const sideNav = {
  menu: [
    {icon: 'home', id: 'home', name: 'Home', url: '/cjm/'},
    {icon: 'asset', id: 'assets', name: 'Assets', url: '/cjm/assets'},
    {icon: 'channel', id: 'channels', name: 'Channels', url: '/cjm/channels'},
    {icon: 'reuse', id: 'lifecycles', name: 'Lifecycles', url: '/cjm/lifecycles'},
    {icon: 'journey', id: 'journeys', name: 'Journeys', url: '/cjm/journeys'},
    {icon: 'trophy', id: 'goals', name: 'Goals', url: '/cjm/goals'},
    {icon: 'message', id: 'messages', name: 'Messages', url: '/cjm/message'},
    {icon: 'segments', id: 'segments', name: 'Segments', url: '/cjm/segments'},
    {icon: 'offer', id: 'offers', name: 'Offers', url: '/cjm/offers'},
    {icon: 'user', id: 'users', name: 'Users', url: '/cjm/users'},
    {icon: 'reports', id: 'reports', name: 'Reports', url: '/cjm/reports'},
    {icon: 'gears', id: 'admin', name: 'Admin', url: '/cjm/admin'}
  ]
};

export const cjmHome = {
  appId: 'cjm-home',
  distributionList: ['Grp-TrojanRabbit'],
  path: '/cjm',
  spaAppId: 'exc-cjm-home',
  sandbox: {
    history: Sandbox.HISTORY_TYPES.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:12399'
    }
  },
  sideNav,
  access: []
};

export const cjmAdmin = {
  base: '/cjm',
  distributionList: ['cjm-dev@adobe.com'],
  appId: 'cjm-admin',
  path: '/cjm/admin',
  type: 'application',
  sandbox: {
    history: Sandbox.HISTORY_TYPES.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:1234',
      qa: 'https://experience-qa.adobe.com/solutions/cjm-admin-app',
      stage: 'https://experience-stage.adobe.com/solutions/cjm-admin-app',
      prod: 'https://experience.adobe.com/solutions/cjm-admin-app'
    },
    ims: {
      client_id: 'cjm-admin',
      scope: 'AdobeID,openid,read_organizations,additional_info.projectedProductContext,additional_info.roles'
    }
  },
  sideNav
};

export const cjmMessage = {
  appId: 'cjm-message',
  distributionList: ['Grp-Content-Authoring-India'],
  path: '/cjm/message',
  type: 'application',
  sandbox: {
    history: Sandbox.HISTORY_TYPES.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:3000',
      qa: 'https://experience-qa.adobe.com/solutions/cjm-message-ui',
      stage: 'https://experience-stage.adobe.com/solutions/cjm-message-ui',
      prod: 'https://experience.adobe.com/solutions/cjm-message-ui'
    },
    ims: {
      client_id: 'cjm-message',
      scope: 'AdobeID, openid, read_organizations'
    }
  },
  sideNav
};
// The solution config for the Journeys Orchestration app
export const cjmJourneys = {
  appId: 'cjm-journeys',
  distributionList: ['GRP-VOYAGER'],
  path: '/cjm/journeys',
  sandbox: {
    history: Sandbox.HISTORY_TYPES.HISTORY,
    ims: {
      client_id: 'voyager',
      scope: 'AdobeID,openid,additional_info.projectedProductContext,read_organizations'
    },
    sources: {
      dev: 'https://localhost.corp.adobe.com/',
      qa: 'https://journeys-dev.adobe.com/',
      stage: 'https://journeys-stage.adobe.com/',
      prod: 'https://journeys.adobe.com/'
    }
  },
  sideNav,
  access: ['bso']
};
// The solution config for the Segments view and manipulation which is a subpath of the JO app
export const cjmSegments = {
  appId: 'cjm-segments',
  distributionList: ['GRP-VOYAGER'],
  path: '/cjm/segments',
  sandbox: {
    history: Sandbox.HISTORY_TYPES.HISTORY,
    ims: {
      client_id: 'voyager',
      scope: 'AdobeID,openid,additional_info.projectedProductContext,read_organizations'
    },
    sources: {
      dev: 'https://localhost.corp.adobe.com/segments',
      qa: 'https://journeys-dev.adobe.com/segments',
      stage: 'https://journeys-stage.adobe.com/segments',
      prod: 'https://journeys.adobe.com/segments'
    }
  },
  sideNav,
  access: ['bso']
};
